import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DxListComponent, DxTagBoxComponent } from 'devextreme-angular';
import { ConstantsService } from 'src/app/services/constants.service';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { Product } from '../../model/resource.model';
import { LookupItem } from '../../model/AS365Defaults.model';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css'],
})
export class AddProductComponent {
  @Output() onProductInputValueChanged: EventEmitter<any> = new EventEmitter();
  @Output() onProductSelected: EventEmitter<any> = new EventEmitter();
  @ViewChild('addProductCtl') addProductCtl: DxTagBoxComponent;
  @ViewChild('productCategoryListCtl') productCategoryListCtl: DxListComponent;
  productList = new Array<Product>(500);
  _productList = new Array<Product>(500);
  productCategoryList: LookupItem[] = [];
  productCategoryLookup: any;
  selectedProductCategoryIds: number[];
  productInputFilter: string;

  @Input() set ProductList(value: Array<Product>) {
    this.productList = value;
    this._productList = value;
  }

  constructor(private constants: ConstantsService) {
    this.productCategoryLookup = AspNetData.createStore({
      key: 'Value',
      loadUrl: '/api/LookupData/GetProductCategoryLookup',
      onBeforeSend: (e, ajax) => {
        ajax = ConstantsService.AddDefaultHeaders(e, ajax);
        ajax.data.OnlyActive = 99999;
      },
      onLoaded: this.onProductCategoryDataLoaded.bind(this),
    });
    this.productCategoryLookup.load();
  }

  onProductCategoryDataLoaded(e: LookupItem[]) {
    this.productCategoryList = e.filter((productCategory) =>
      this.productList.some((product) =>
        product.ProductCategoryLink.some(
          (productCategoryLink) => productCategoryLink.ProductCategory == productCategory.Value
        )
      )
    );
  }

  onProductCategoryListSelectionChanged() {
    this.selectedProductCategoryIds = (<LookupItem[]>(
      this.productCategoryListCtl.instance.option('selectedItems')
    )).map((productCategory) => productCategory.Value);

    this.applyFilters();
  }

  applyFilters() {
    let productList = this.productList;

    if (this.selectedProductCategoryIds?.length > 0) {
      productList = this.productList.filter((product) =>
        this.selectedProductCategoryIds.every((productCategoryId) =>
          product.ProductCategoryLink.some(
            (productCategoryLink) => productCategoryId == productCategoryLink.ProductCategory
          )
        )
      );
    }

    if (this.productInputFilter?.trim().length > 0) {
      productList = productList.filter((i) =>
        i.ProductName.trim().toLowerCase().includes(this.productInputFilter.trim().toLowerCase())
      );
    }

    this._productList = productList;
  }

  onProductListItemClick(e: any) {
    this.onProductSelected.emit(e.itemData as Product);
  }

  onInput(e) {
    this.productInputFilter = e.event.target.value;
    this.applyFilters();
    this.onProductInputValueChanged.emit(this.productInputFilter);
  }
}
